import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_table, {
      ref: "table",
      bordered: "",
      rowKey: _ctx.rowKey,
      childrenColumnName: _ctx.childrenColumnName,
      dataSource: _ctx.dataSource,
      columns: _ctx.tableColumns,
      "row-selection": _ctx.rowSelection,
      pagination: false,
      onChange: _ctx.change,
      loading: _ctx.loading,
      defaultExpandAllRows: true,
      tableLayout: "fixed",
      scroll: { x: 'max-content',y: _ctx.tableHeight},
      onResizeColumn: _ctx.handleResizeColumn
    }, {
      headerCell: _withCtx(({ column }) => [
        _renderSlot(_ctx.$slots, "headerCell", { column: column })
      ]),
      bodyCell: _withCtx(({ column, record, index, text }) => [
        _renderSlot(_ctx.$slots, "bodyCell", {
          column: column,
          record: record,
          index: index,
          text: text
        })
      ]),
      _: 3
    }, 8, ["rowKey", "childrenColumnName", "dataSource", "columns", "row-selection", "onChange", "loading", "scroll", "onResizeColumn"]),
    (_ctx.showPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_pagination, {
            current: _ctx.current,
            pageSize: _ctx.pageSize,
            total: _ctx.total,
            "show-quick-jumper": true,
            "show-size-changer": true,
            "page-size-options": _ctx.pageSizeOptions,
            "show-total": total => `共${total}条`,
            onChange: _ctx.change
          }, null, 8, ["current", "pageSize", "total", "page-size-options", "show-total", "onChange"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}